import React, { useState, useRef, useEffect } from "react";
import "./WhatsAppBot.css";

function WhatsAppBot({ isOpen, setIsOpen }) {
    const [inputValue, setInputValue] = useState("");
    const [chat, setChat] = useState([
        { text: "👋 Welcome to AI Gurukul! How can I help you today? Click a question below to get answers instantly!", type: "bot" }
    ]);
    const chatEndRef = useRef(null);
    const questionsRef = useRef(null);
    const chatbotRef = useRef(null);

    // Expert Numbers
    // Expert Numbers (Restored to original config)
    const CONTACTS = [
        { phone: "919225584952", slot: "morning" },
        { phone: "919822217064", slot: "afternoon" },
        { phone: "919822219735", slot: "evening" }
    ];

    const getExpertNumber = () => {
        const hour = new Date().getHours();
        if (hour >= 6 && hour < 12) return CONTACTS[0].phone;
        if (hour >= 12 && hour < 18) return CONTACTS[1].phone;
        return CONTACTS[2].phone;
    };

    const FAQS = [
        { q: "Will this help in future studies?", a: "🎓 Yes! It builds strong logical thinking and problem-solving for school, college, and your future career." },
        { q: "Is AI useful for exams?", a: "✅ Yes! It helps in understanding complex concepts, creating projects, and research." },
        { q: "What will I learn?", a: "📚 You'll learn AI basics, productivity tools, and how to build your own AI projects!" },
        { q: "Do I need coding knowledge?", a: "❌ No coding required for school/college programs. We teach you from zero!" },
        { q: "Will I get a certificate?", a: "📜 Yes! Certified by The DataTech Labs. Great for your Resume!" },
        { q: "Is AI difficult?", a: "❌ No! We make AI easy and fun to learn with practical examples." }
    ];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (chatbotRef.current && !chatbotRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [setIsOpen]);

    useEffect(() => {
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [chat, isOpen]);

    const handleFaqClick = (faq) => {
        setChat([
            ...chat,
            { text: faq.q, type: "user" },
            { text: faq.a, type: "bot" }
        ]);
    };

    const handleCustomSubmit = (e) => {
        e.preventDefault();
        const msg = inputValue.toLowerCase().trim();
        if (!msg) return;

        const userMsg = { text: inputValue, type: "user" };
        let botResponse = "That's a great question! I'm still learning, but you can connect with our experts below for a detailed answer! 👇";

        // GREETING LOGIC
        const greetings = ['hi', 'hello', 'hey', 'hii', 'hy'];
        if (greetings.includes(msg)) {
            const hour = new Date().getHours();
            let timeGreeting = "Good Evening";
            if (hour >= 5 && hour < 12) timeGreeting = "Good Morning";
            else if (hour >= 12 && hour < 18) timeGreeting = "Good Afternoon";

            botResponse = `👋 ${timeGreeting}! Welcome to AI Gurukul. How can I help you today? You can ask about our courses, certification, or future studies!`;
        }

        setChat([
            ...chat,
            userMsg,
            { text: botResponse, type: "bot" }
        ]);
        setInputValue("");
    };

    const handleConnect = () => {
        const number = getExpertNumber();
        const message = encodeURIComponent("Hi, I have a question about AI Gurukul.");
        window.open(`https://wa.me/${number}?text=${message}`, '_blank');
    };

    return (
        <div className={`whatsapp-bot-wrapper ${isOpen ? 'open' : ''}`} ref={chatbotRef}>
            <div className="whatsapp-bot-container">
                <div className="whatsapp-bot-header">
                    <div className="bot-info">
                        <div className="bot-avatar">🤖</div>
                        <div>
                            <div className="bot-name">AI Gurukul Assistant</div>
                            <div className="bot-status">Online</div>
                        </div>
                    </div>
                </div>

                <div className="whatsapp-chat-box">
                    {chat.map((msg, i) => (
                        <div key={i} className={`whatsapp-msg ${msg.type}`}>
                            {msg.text}
                        </div>
                    ))}
                    <div ref={chatEndRef} />
                </div>

                <div className="whatsapp-footer">
                    <div className="faq-scroll" ref={questionsRef}>
                        {FAQS.map((faq, i) => (
                            <button key={i} onClick={() => handleFaqClick(faq)} className="whatsapp-faq-btn">
                                {faq.q}
                            </button>
                        ))}
                    </div>

                    <form className="whatsapp-input-area" onSubmit={handleCustomSubmit}>
                        <input
                            type="text"
                            placeholder="Type a message..."
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                        />
                        <button type="submit" disabled={!inputValue.trim()}>➤</button>
                    </form>

                    <button className="whatsapp-connect-btn" onClick={handleConnect}>
                        <span>Connect to Expert</span>
                        <span className="whatsapp-icon">💬</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default WhatsAppBot;
